import { TokenTextColor, TextAlignment, TokenTextAppearance, Text } from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';

const StyledTextLegal = styled(Text)`
	font-size: 12px;
`;

interface TextLegalProps {
	children: React.ReactNode;
	isPDF?: boolean;
}

export const DisclaimerTextLegal = ({ children, isPDF = false }: TextLegalProps): React.JSX.Element => {
	if (isPDF) {
		return (
			<StyledTextLegal color={TokenTextColor.tertiary} textAlign={TextAlignment.center}>
				{children}
			</StyledTextLegal>
		);
	}

	return (
		<Text appearance={TokenTextAppearance.copy100} color={TokenTextColor.tertiary} textAlign={TextAlignment.center}>
			{children}
		</Text>
	);
};
